function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4,5.0004 L12,5.0004 L12,4.0004 L4,4.0004 L4,5.0004 Z M4,8.0004 L12,8.0004 L12,7.0004 L4,7.0004 L4,8.0004 Z M4,11.0004 L12,11.0004 L12,10.0004 L4,10.0004 L4,11.0004 Z M16,2.0004 L16,13.0004 C16,14.1044 15.104,15.0004 14,15.0004 L5.207,15.0004 C5.074,15.0004 4.947,15.0524 4.854,15.1464 L2.854,17.1464 C2.752,17.2484 2.627,17.2944 2.504,17.2944 C2.246,17.2944 2,17.0934 2,16.7934 L2,15.0004 C0.896,15.0004 0,14.1044 0,13.0004 L0,2.0004 C0,0.8954 0.896,0.0004 2,0.0004 L14,0.0004 C15.104,0.0004 16,0.8954 16,2.0004 Z M18,3 C19.104,3 20,3.896 20,5 L20,16 C20,17.104 19.104,18 18,18 L18,19.295 C18,19.926 17.233,20.238 16.792,19.787 L15.127,18.085 C15.066,18.06 14.985,18.025 14.926,18 L6,18 C5.298,18 4.683,17.637 4.325,17.089 L5.414,16 L14,16 C15.654,16 17,14.654 17,13 L17,3 L18,3 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/chat.8e9162c2.svg";
export { SvgComponent as ReactComponent };